module.exports = __webpack_public_path__ + "img/sample.a9df8b50.png";